import * as React from 'react';

import { IconX } from '~shared/components/icons/micro';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement>;

const ImageFieldClear = (props: Props) => {
  return (
    <button
      {...props}
      className="w-10 h-10 p-0 bg-transparent text-grey-500 hover:text-red-700 focus:text-red-700 focus:shadow-outline border-0 rounded-tr-1 rounded-bl-1 outline-none cursor-pointer appearance-none image-field__clear"
    >
      <div className="flex relative items-center justify-center">
        <IconX />
      </div>
    </button>
  );
};

export default ImageFieldClear;
